<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height class="login-background">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6" lg="4">
            <v-card class="glass-card elevation-12 pa-4">
              <v-card-text>
                <div class="text-center mb-4">
                  <img
                    :src="$vuetify.theme.dark ? '/SPACE-logo-light.png' : '/SPACE-logo-dark.png'"
                    alt="Logo"
                    height="60"
                    class="mb-4"
                  />
                  <h2 class="text-h4 mb-2">VPN Status Dashboard</h2>
                  <p class="text-subtitle-1 grey--text">Sign in to continue</p>
                </div>

                <v-form ref="form" v-model="valid" @submit.prevent="login">
                  <v-text-field
                    v-model="username"
                    label="Username"
                    prepend-icon="person"
                    :rules="[rules.required]"
                    outlined
                    dense
                    class="mb-2"
                    :disabled="loading"
                    @keyup.enter="login"
                  />

                  <v-text-field
                    v-model="password"
                    label="Password"
                    prepend-icon="lock"
                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[rules.required]"
                    outlined
                    dense
                    class="mb-2"
                    :disabled="loading"
                    @click:append="showPassword = !showPassword"
                    @keyup.enter="login"
                  />

                  <v-checkbox
                    v-model="rememberMe"
                    label="Remember username"
                    color="primary"
                    dense
                    class="mt-0"
                    :disabled="loading"
                  />

                  <v-alert
                    v-if="errorMessage"
                    type="error"
                    dense
                    text
                    dismissible
                    class="mb-3"
                    @input="errorMessage = ''"
                  >
                    {{ errorMessage }}
                  </v-alert>

                  <v-btn
                    type="submit"
                    color="primary"
                    block
                    large
                    :loading="loading"
                    :disabled="!valid || loading"
                    class="mt-2"
                  >
                    Sign In
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data() {
    return {
      valid: false,
      loading: false,
      username: '',
      password: '',
      rememberMe: false,
      showPassword: false,
      errorMessage: '',
      rules: {
        required: value => !!value || 'Required field'
      }
    }
  },
  mounted() {
    const savedUsername = localStorage.getItem('rememberedUsername')
    if (savedUsername) {
      this.username = savedUsername
      this.rememberMe = true
    }
  },
  methods: {
    async login() {
      if (!this.$refs.form.validate())
        return

      this.loading = true
      this.errorMessage = ''

      try {
        // Call secure login API with credentials
        const response = await axios.post('/api/login', {
          username: this.username,
          password: this.password
        }, {
          withCredentials: true
        })

        if (response.data.success) {
          // Mark as authenticated (cookie is set automatically)
          sessionStorage.setItem('isAuthenticated', 'true')

          // Handle remember username
          if (this.rememberMe)
            localStorage.setItem('rememberedUsername', this.username)
          else
            localStorage.removeItem('rememberedUsername')

          this.$router.push('/0/clients')
        }
      } catch (error) {
        if (error.response && error.response.status === 401)
          this.errorMessage = error.response.data.error || 'Invalid username or password'
        else if (error.response && error.response.status === 429)
          this.errorMessage = 'Too many login attempts. Please try again later.'
        else if (error.response)
          this.errorMessage = error.response.data.error || 'Login failed'
        else
          this.errorMessage = 'Connection error. Please try again.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-background {
  background: linear-gradient(135deg, #217ee2 0%, #1565c0 100%);
  min-height: 100vh;
}

.theme--dark .login-background {
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%);
}

.glass-card {
  backdrop-filter: blur(10px) saturate(180%);
  -webkit-backdrop-filter: blur(10px) saturate(180%);
  background: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 24px !important;
}

.theme--dark .glass-card {
  background: rgba(30, 30, 30, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
</style>
